import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './sports.json';

const Sports = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Sports vocabulary, fitness, and athletic discussions. B2 level grammar, vocabulary, and speaking exercises."
            level="B2"
            title="Watching Sports"
            image="/Images/sports.webp"
            seoTitle="Free English Lesson Plans: Sports"
            seoDescription="Sports vocabulary, fitness, and athletic discussions. B2 level grammar, vocabulary, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Sports;


